// extracted by mini-css-extract-plugin
module.exports = {"linkPurchase":"Layout-module--linkPurchase--j6yon","purchaseButton":"Layout-module--purchaseButton--1vj0G"};